import { analyzeSelfie } from "./visionAI";

export function mapDirection(detected) {
  switch ((detected || "").toLowerCase()) {
    case "male": return "masculine";
    case "female": return "feminine";
    case "neutral": return "androgynous";
    default: return null;
  }
}

// styleEngine.detectUserStyle(photo)
export async function detectUserStyle(photo, occasion) {
  const b64 = (photo || "").split(",")[1] || photo;
  const analysis = await analyzeSelfie(b64, occasion || "Special Occasion");
  return { analysis, direction: mapDirection(analysis.styleDirection) };
}
